export const TAG_PARTS = [
  'container',
  'label',
  'leftAction',
  'rightAction',
  'icon',
] as const;
